<template>
<div>
  <el-dialog
    :title="mark==1 ? '编辑联系人' :'新建联系人'"
    width="742px"
    custom-class="concat-dialog"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :append-to-body="true"
    @open='handleOpen'
    @close="handleClose('ruleForm')"
  >
    <div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="contactName">
              <el-input 
                size="small" 
                maxlength="30" 
                v-model="ruleForm.contactName" 
                placeholder="请输入" 
                style="width:220px;"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称" prop="companyName">
              <el-select
                v-if="mark && !customerId"
                v-model="ruleForm.customerId"
                style="width:220px;color: #C0C4CC;"
                filterable
              >
                <el-option
                  v-for="item in customerList"
                  :value="item.id"
                  :key="item.id"
                  :label="item.companyName"
                >
                </el-option>
              </el-select>
              <el-input 
                v-else
                class="disableinput"
                :disabled="true" 
                size="small" 
                maxlength="30" 
                v-model="ruleForm.companyName" 
                placeholder="请输入" 
                style="width:220px;"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="职务" prop="title">
              <el-select
                style="width:220px;"
                v-model="ruleForm.title"
                filterable
                allow-create
                default-first-option
                clearable
                reserve-keyword
                @input.native="titleInput"
                ref="titleSelect"
                placeholder="请输入">
                <el-option
                  v-for="item in titleListOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="国家区号" prop="code">
              <div>
                <el-select 
                  @change="codeTelChange" 
                  size="small"  
                  filterable
                  style="width: 220px;" 
                  v-model="ruleForm.codeTel" 
                  placeholder="请选择"  
                >
                  <el-option
                    v-for="item in cityCodeList"
                    :key="item.codeValue"
                    :label="item.codeTel + ' ' + item.name"
                    :value="item.codeValue">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="手机" prop="mobile">
              <div style="display:flex;align-items: center;width: 220px;">
                <div class="contact-button" >{{ruleForm.codeTelStr}}</div>
                <el-input 
                  class="phoneInput"
                  v-model="ruleForm.mobile"  
                  size="small" 
                  placeholder="请输入" 
                  maxlength="20"
                >
                </el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="padding-left:0;">
            <el-form-item label="电话号码" prop="tel" >
              <div style="display:flex;align-items: center;width: 220px;">
                <div class="contact-button">{{ruleForm.codeTelStr}}</div>
                <el-input 
                  class="phoneInput" 
                  v-model="ruleForm.tel"   
                  size="small"  
                  placeholder="请输入"
                  maxlength="20"
                >
                </el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
           <el-col :span="12" >
            <el-form-item label="邮箱" prop="email">
              <el-input 
                v-model="ruleForm.email" 
                maxlength="100" 
                size="small"  
                placeholder="请输入" 
                style="width:220px;"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="padding-left:0;">
            <el-form-item label="微信号" prop="wechatNo" >
              <el-input 
                maxlength="30" 
                v-model="ruleForm.wechatNo" 
                size="small"  
                placeholder="请输入" 
                style="width:220px;"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
           <el-col :span="12" >
            <el-form-item label="whatsapp" prop="whatsApp">
              <el-input 
                maxlength="30" 
                v-model="ruleForm.whatsApp" 
                size="small"  
                placeholder="请输入" 
                style="width:220px;"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="padding-left:0;">
            <el-form-item label="Linkedin" prop="linkedinLink" >
              <el-input 
                maxlength="500" 
                v-model="ruleForm.linkedinLink"  
                size="small"  
                placeholder="请输入" 
                style="width:220px;"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
           <el-col :span="12" >
            <el-form-item label="备注" prop="remark">
              <el-input 
                maxlength="500"
                resize='none'
                type="textarea" 
                v-model="ruleForm.remark" 
                size="small"  
                placeholder="请输入" 
                style="width:220px;"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="padding-left:0;">
           
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel('ruleForm')" size="small" style="width:56px;color:#16181A">取 消</el-button>
      <el-button type="primary" size="small" style="width:56px" @click="confirm('ruleForm')">确 定</el-button>
    </span>
  </el-dialog>

</div>
</template>

<script>
import {
  addContact,
  editContact,
  deleteContact,
} from '@/utils/api/customerdetail';
import {commonDictCityCode} from '@/utils/api/area'
import { getSearchCustomerName } from '@/utils/api/customer'
import { getDictByType, } from '@/utils/api/common.js';
import { userTitleByKeyword } from '@/utils/api/edmSubject'
export default {
  props: {
    // 这里给一个默认值，不然编辑的时候取不到
    copyDetailData: {
      default: () => ({})
    },
  
  },
  data(){
    // 最大输入校验 num: 需要检验的最大位数
    const maxLengthRule = (rule, value, callback, num) => {
      value = value || "";
      if (value.length > num) {
        return callback(new Error(`内容不能大于${num}个字符`));
      } else{
        callback()
      }
    };
    
    //邮箱验证
    const checkEmail = (rule, value, callback) => {
      value = value || "";
      if (!value || value.trim() =='') {
        return callback(new Error(`内容不能为空`));
      } else{
        callback()
      }
    };
    // 手机号、电话验证规则
    const checkTelTwo = (rule, value, callback) => {
      value = value || "";
      if (value == "") {
        return callback();
      } else {
        const reg = /^[0-9]{6,20}$/;
        if (value.length > 20) {
          return callback(
            new Error(`请输入6-20位数字`)
          );
        } else if (!reg.test(value)) {
          return callback(
            new Error(`请输入6-20位数字`)
          );
        } else {
          callback();
        }
      }
    };
    return {
      isLoading: false, //当前提交状态
      dialogVisible: false,
      mark: 0,   //判断是新建还是编辑
      ruleForm:{
        codeTel: '',
        codeTelStr:'',
        companyName: this.copyDetailData.companyName,
        contactName:'',
        name:'',
        email:'',
        id:'',
        linkedinLink:'',
        mobile:'',
        showContactInfo:'',
        tel:'',
        title:'',
        wechatNo:'',
        whatsApp:'',
        remarks:'',
        customerId: '',
      },
      rules: {
        contactName: [
          { required: true,validator:checkEmail, trigger: 'blur' },
          { validator: (rule, value, callback) => maxLengthRule(rule, value, callback, 30), trigger: 'blur' },
        ],
        email:[
         { required: false,type:"email", message: '邮箱格式不正确', trigger: 'blur' },
         { validator: (rule, value, callback) => maxLengthRule(rule, value, callback, 100), trigger: 'blur' },
        ],
        mobile:[
          { required: false,validator: checkTelTwo, trigger: 'blur'},
          { validator: (rule, value, callback) => maxLengthRule(rule, value, callback, 20), trigger: 'blur' },
        ],
        tel:[
          { required: false,validator: checkTelTwo, trigger: 'blur' },
          { validator: (rule, value, callback) => maxLengthRule(rule, value, callback, 20), trigger: 'blur' },
        ],
        wechatNo: [
          { validator: (rule, value, callback) => maxLengthRule(rule, value, callback, 30), trigger: 'blur' },
        ],
        whatsApp: [
          { validator: (rule, value, callback) => maxLengthRule(rule, value, callback, 30), trigger: 'blur' },
        ],
        linkedinLink: [
          { validator: (rule, value, callback) => maxLengthRule(rule, value, callback, 500), trigger: 'blur' },
        ],
        remark: [
          { validator: (rule, value, callback) => maxLengthRule(rule, value, callback, 500), trigger: 'blur' },
        ],
      },
    
      cityCodeList:[],
      customerList: [],
      isClick: false,
      titleListOptions:[]
    }
  },
  methods: {
    // 初始化选项数据(职务)
    async getInitData() {
      try {
        const res = await getDictByType([
          { key: 'saas_supplier_customer_title'}
        ])
        if (res.rspResult.bizCode === 200) {
          const {
            codeMap: {
              saas_supplier_customer_title
            },
          } = res.data
        }
      } catch(err) {
        console.error("❌ ~ file: newcontactDialog.vue:352 ~ getInitData ~ err:", err)
      }
    },
    // 获取国家区号
    getCityCode(){
      commonDictCityCode()
        .then(res=>{
          if(res.rspResult.bizCode == 200){
            this.cityCodeList = res.rspListData.list || [];
            if(this.mark) return // 如果是编辑，不设置默认值
            let a = this.cityCodeList.findIndex(item=>{
              return this.copyDetailData.countryStr == item.name 
            })
            this.ruleForm.codeTel = this.copyDetailData.countryStr ? this.cityCodeList[a].codeValue : this.cityCodeList[40].codeValue
            this.ruleForm.codeTelStr = this.copyDetailData.countryStr ? this.cityCodeList[a].codeTel : this.cityCodeList[40].codeTel
          }
        })
        .catch(err => console.error('获取国家区号失败',err))
    },
    // 获取列表信息
    getContact(val,mark){
      this.ruleForm = JSON.parse(JSON.stringify(val)) ;
      this.customerId = this.ruleForm.customerId
      this.mark = mark;
    },
    // 添加联系人
    addContactList(val){
      this.isLoading = true;
      addContact(val)
        .then(res=>{
          this.isLoading = false;
          if(res.rspResult.bizCode == 200){
            this.$message({
              message: '保存成功',
              type: 'success'
            });
          this.dialogVisible = false;
          this.$emit('getContactList')
          }
        })
        .catch((err)=>{
          this.isLoading = false;
          console.error('新建联系人失败',err)
        });
    },
    // 编辑联系人
    editContactList(val){
      this.isLoading = true;
      editContact(val)
        .then(res=>{
          this.isLoading = false;
          if(res.rspResult.bizCode == 200){
            this.$message({
              message: '编辑成功',
              type: 'success'
            });
            this.$emit('getContactDetail')
            this.dialogVisible = false;
          }
        })
        .catch(err=> {
          this.isLoading = false;
          console.error('编辑联系人信息失败',err);
        });
    },
    // 取消
    cancel(formName){
      setTimeout(()=>{
        this.mark = 0;
      },500)
      this.$refs[formName].resetFields();
      if(this.mark==1){
        this.$emit('getContactList');
      }
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    // 确定
    confirm(formName){
      if(this.isLoading) return;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          if(this.mark == 1) return this.update();
          // if(this.isClick) return;
          // this.isClick = true;
          const params = { 
            contactName: this.ruleForm.contactName.trim(),
            companyName: this.ruleForm.companyName,
            customerId: this.copyDetailData.id,
            codeTel: this.ruleForm.codeTel,  //国家区号
            email: this.ruleForm.email.trim(),
            mobile: this.ruleForm.mobile.trim(), //手机
            tel: this.ruleForm.tel.trim(),  //电话
            wechatNo: this.ruleForm.wechatNo.trim(),  //微信
            linkedinLink: this.ruleForm.linkedinLink.trim(),
            whatsApp: this.ruleForm.whatsApp.trim(),
            remark: this.ruleForm.remark,
          }
          // 判断职位的类型，如果字符串，代表是自定义的
          if(typeof this.ruleForm.title === 'string') {
            params.customTitle = this.ruleForm.title || undefined
          } else {
            // 数字类型代表是id
            params.title = this.ruleForm.title || undefined
          }        
          this.addContactList(params)

          // if(this.mark == 1){
          //   this.editContactList(params1);
          // }else{
          //   this.addContactList(params2)
          // }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 限制输入为非数字
    // limitInputValue(e){
    //   if(e.key ==='e' || e.key ==='E'){
    //     e.returnValue = false
    //     return false 
    //   }
    //   return true
    // },
    handleOpen(){
      this.getCityCode()
      if(!this.mark) this.ruleForm.companyName = this.copyDetailData.companyName // 当非编辑时才根据客户详情设置客户名称
      this.getTitleList()
      this.$nextTick(()=>{
        this.selectLength()
      })
    },
    handleClose(formName){
      this.ruleForm = {
        codeTel:'',
        companyName: this.copyDetailData.companyName,
        contactName:'',
        name:'',
        email:'',
        id:'',
        linkedinLink:'',
        mobile:'',
        showContactInfo:'',
        tel:'',
        title:'',
        wechatNo:'',
        whatsApp:'',
        remarks:'',
      }
      this.$refs[formName].resetFields();
      this.titleListOptions = [];
    },
    // 限制select输入字数
    selectLength(){
      const selectId = document.querySelector('#titleSelect')
      const inputId = document.querySelector('#phoneInput')
      if(selectId){
        selectId.setAttribute('maxlength',30)
      }
      if(inputId){
        inputId.setAttribute('maxlength',20)

      }
    },
    // 编辑联系人
    update() {
      const params = { 
        contactName: this.ruleForm.contactName?.trim(),
        companyName: this.ruleForm.companyName?.trim(),
        customerId: this.ruleForm.customerId,
        codeTel: this.ruleForm.codeTel,  //国家区号
        email: this.ruleForm.email?.trim(),
        mobile: this.ruleForm.mobile, //手机
        tel: this.ruleForm.tel,  //电话
        wechatNo: this.ruleForm.wechatNo?.trim(),  //微信
        linkedinLink: this.ruleForm.linkedinLink?.trim(),
        whatsApp: this.ruleForm.whatsApp?.trim(),
        id: this.ruleForm.id,
        remark: this.ruleForm.remark,
      }
      // 判断职位的类型，如果字符串，代表是自定义的
      if(typeof this.ruleForm.title === 'string') {
        params.customTitle = this.ruleForm.title || undefined
      } else {
        params.title = this.ruleForm.title || this.ruleForm.copyTitle
      }     
      this.editContactList(params);
    },
    
    // 获取当前登录用户的所有客户名称
    async searchCustomerName() {
      try {
        const res = await getSearchCustomerName({
          customerName: ""
        })
        if(res.rspResult.bizCode === 200) {
          this.customerList = res.rspListData.list
          // if(!this.customerList?.length) this.ruleForm.title = this.ruleForm.
        }
      } catch(err) {
        console.error("❌ ~ file: newcontactDialog.vue:550 ~ searchCustomerName ~ err:", err)
      }
    },
    // 当国家区号发生变化时
    codeTelChange(val) {
      this.ruleForm.codeTelStr = this.cityCodeList.find(ele => ele.codeValue === val).codeTel
    },
    
    async getTitleList(val) {
      try {
        const res = await userTitleByKeyword({keyword: ''})
        if(res.rspResult.bizCode === 200) {
          this.titleListOptions = res.rspListData.list
        }
      } catch(err) {
        console.error("❌ ~ file: newcontactDialog.vue:565 ~ remoteMethod ~ err:", err)
      }
    },


    // 当职位输入值发生变化时
    titleInput(value) {
      try {
        var str = this.$refs.titleSelect.$data.selectedLabel// 此属性得到输入的文字
        // 控制的js
        if(str.length>30){this.$refs.titleSelect.$data.selectedLabel = str.substr(0,30)}
      } catch(err) {
        console.error("❌ ~ file: newcontactDialog.vue:576 ~ titleInput ~ err:", err)
      }
    }
  },
  created(){
    this.getInitData()
  },
 
}
</script>

<style lang="scss" scoped>
.contact-button{
  width: 60px;
  height:30px;
  text-align: center;
  position: relative;
  /* top: 1px; */
  padding:0;
  background: #F5F7FA;
  border-radius: 4px 0 0 4px;
  border: 1px solid #DCDFE6;
  // border-right:none;
  flex-shrink: 0;
}
::v-deep .disableinput{
  .el-input__inner{
    color: #4F5D78 !important;
  }
}
::v-deep .contact-button{
  .el-button--small{
    color:#4F5D78;
  }
  .el-button--small:hover{
    border-color:none;
  }
}
::v-deep.phoneInput{
  height: 32px;
  .el-input__inner{
    border-left: none;
    border-radius: 0 4px 4px 0 !important;
    flex: auto;
  }
}
::v-deep .concat-dialog{
  .el-row{
    left: -8px;
    .el-col {
      &:last-child {
        padding-left: 10px !important;
      }
    }
  }
  .el-dialog__header{
    padding: 24px 32px 0 32px;
  }
  .el-dialog__body{
    padding-bottom:  0;
    padding-top: 28px;
    padding-left: 25px;
  }
  .el-dialog__footer{
    padding: 8px 32px 32px 32px;
  }
  .el-dialog__headerbtn{
    width: 14px;
    top: 32px;
    right: 32px;
  }
  .el-dialog__title{
    font-size: 16px;
    color: #16181A;
    font-weight: 500;
  }
  .el-form-item__label{
    font-size: 14px;
    color: #4F5D78;
  }
  .el-input__inner{
    font-size: 14px;
    color: #16181A;
  }
  .el-input.is-disabled .el-input__inner{
    color: #C0C4CC;
  }
  .el-textarea__inner {
    font-size: 14px;
  }
  .dialog-footer {
    .el-button {
      font-size: 14px;
    }
  }
}
::v-deep .el-button--small{
  padding:9px 9px;
}
// input type:number 样式
::v-deep input::-webkit-inner-spin-button{
  -webkit-appearance: none !important;
}
::v-deep input::-webkit-outer-spin-button{
  -webkit-appearance: none !important;
}
</style>